export  const prizesDictionary = {
phoecoinPaymentTxt:{fa:"فیکوین از شما کسر خواهد شد، آیا اطمینان دارید؟" , en:"Phoecoins will be deducted from you, do you confirm?"},
purchase:{fa:"خرید" , en:"Purchase"},
discountCode:{fa:"کد تخفیف" , en:"Discount code"},
expDate:{fa:"تاریخ انقضا" , en:"Expiration date"},
header:{fa:"<h1 class='text-right mx-2'>جوایز</h1>"+"<h2 class='text-right mx-2'>"+"میتوانید فیکوین های خود را"  + "در این قسمت تبدیل به جایزه کنید"+"</h2>" ,
en:"<h1 class='text-left mx-2 '>Awards</h1>"+"<h2 class='text-left mx-2 '>Change your Phoecoins to prize</h2>"},
see:{fa:"مشاهده" , en:"See prizes"},
get:{fa:"دریافت" , en:"Get"},
charge:{fa:"شارژ" , en:"charge"}

}